import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class TaskService {
    public Tastdata: any;

    constructor(private httpService: HttpService) { }


    obtainTaskLocation(search: any) {
        const url = `${environment.TaskApiendpoint}/task/getAllListLoctionbyTaskId`;
        return this.httpService.post(url,{task_id:search}, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getPendingLocation(item_id: any,status:any) {

      const url = `${environment.TaskApiendpoint}/task/location/list/${item_id}${status?'?status='+status:''}`;
      return this.httpService.get(url, this.httpService.headers)
          .pipe(
              catchError(this.Errorhandling)
          );
  }


    getallTourbyrunner(data:any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/get-sheduledtask-assigned-runner/${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }
    exportItemsReports(data:any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/export-excel-items?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }
    exportLocationReports(data:any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/export-excel-location?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }

    exportDistanceReports(data:any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/export-excel-distance?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }
    uploadFileDataBulkTask(data:any, imagefile: any) {
        const url = `${environment.TaskApiendpoint}/task/upload-task-data/${data.client_id}/${imagefile}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    uploadFileBulkTask(data:any, imagefile: File) {
        const url = `${environment.TaskApiendpoint}/task/upload-task`;
        const formData = new FormData();

        formData.append('file', imagefile);
            formData.append('client_id',data.client_id);

        return this.httpService
            .post(url, formData, this.httpService.headers)
            .pipe(catchError(this.Errorhandling));
    }
    uploadFileData(data:any, imagefile: any) {
        const url = `${environment.TaskApiendpoint}/task/upload-data/${data.client_id}/${data.customer_id}/${imagefile}`;
      //  const url = `${environment.LocaionApiendpoint}/location/upload-data/${data.client_id}/${data.customer_id}/${imagefile}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)

                );
    }
    getBarcodes(item_id: any) {

        const url = `${environment.TaskApiendpoint}/task/get-item-child-barcode/${item_id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    get_location_photo(task_id: any,location_id: any) {

        const url = `${environment.TaskApiendpoint}/task/get-location-photo/${task_id}/${location_id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    editLocation(data: any, id: any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/edit-location/${id}`
        return this.httpService.put(url, data, this.httpService.headers)
    }
    getCollectedNum(search: any,search1: any) {

        const url = `${environment.TaskApiendpoint}/task/all-collected/${search}/${search1}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getDeliveredNum(search: any,search1: any) {

        const url = `${environment.TaskApiendpoint}/task/all-delivered/${search}/${search1}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    markCollected(search: any) {

        const url = `${environment.TaskApiendpoint}/task/tour-complete/${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    obtainItemReports(search: any) {

        const url = `${environment.TaskApiendpoint}/task/item-reports?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    obtainReports(search: any) {

        const url = `${environment.TaskApiendpoint}/task/reports?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    obtainDistanceReports(search: any) {

        const url = `${environment.TaskApiendpoint}/task/get-runner-distance?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    editMultipleLocation( data: any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/add-multiple-location/`
        return this.httpService.post(url,data, this.httpService.headers)
    }
    onAssignTask( data: any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/assign-task/`
        return this.httpService.post(url,data, this.httpService.headers)
    }
    obtainLocationLiveView(search: any) {
        const url = `${environment.TaskApiendpoint}/task/location_live_view?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    obtainRunnersLiveView(search: any) {
        const url = `${environment.TaskApiendpoint}/task/runner_live_view?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    obtainTaskLiveView(search: any) {
        const url = `${environment.TaskApiendpoint}/task/task_live_view?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    addTaskLocation(data: any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/add-ondemand-location`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    addTaskOndemand(data: any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/add-ondemand`
        return  this.httpService.post(url, data, this.httpService.headers)

    }
    addTask(data: any): Observable<any> {

        const url = `${environment.TaskApiendpoint}/task/add`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    deleteTask(data: any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/delete/${data}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateStatus(id: any, status: any): Observable<any> {
        const url = `${environment.TaskApiendpoint}/task/${id}/${status}`
        return this.httpService.get(url, this.httpService.headers)
    }
    obtainTasks(search: any) {
      const url = `${environment.TaskApiendpoint}/task/list?${search}`;
      return this.httpService.get(url, this.httpService.headers)
          .pipe(
              catchError(this.Errorhandling)
          );
  }
  editTask(data: any, Tour: any): Observable<any> {
    const url = `${environment.TaskApiendpoint}/task/edit/${Tour}`
    return this.httpService.put(url, data, this.httpService.headers)
}
  obtainTask(search: any) {
    const url = `${environment.TaskApiendpoint}/task/detail/${search}`;
    return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
}
obtainAllTodayLocation(search: any) {
    const url = `${environment.TaskApiendpoint}/task/all-location-byrunner/${search}`;
    return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
}

obtainAllRunnerGPSLatLong(latN:any,latS:any,lonE:any,lonW:any) {
    const url = `${environment.TaskApiendpoint}/task/get-all-runner-gps-cord`;
    return this.httpService.post(url,{latN,latS,lonE,lonW}, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );

}
obtainAllRunnerGPS(city_id:any) {
    const url = `${environment.TaskApiendpoint}/task/get-all-runner-gps/${city_id}`;
    return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
}

obtainTaskGPS(runner_id:any) {
    const url = `${environment.TaskApiendpoint}/task/get-all-gps-task_web/${runner_id}`;
    return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
}
deleteTaskLocaion(id: any) {
    const url = `${environment.TaskApiendpoint}/task/delete_location_bytask/${id}`;
    return this.httpService.delete(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
}
makeStartPoint(user: any) {

    const url = `${environment.TaskApiendpoint}/task/make-start-point/${user.id}/${user.task_id}`;
    return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
}

makeEndPoint(user: any) {
    const url = `${environment.TaskApiendpoint}/task/make-end-point/${user.id}/${user.task_id}`;
    return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
}
  Errorhandling(err: HttpErrorResponse) {
    if (err.error instanceof ErrorEvent) {
        console.error(err.error.message);
    } else {
        console.error(`Backend returned code ${err.status}`);
    }
    return throwError('Please try again later.');
}
}

